import { Empty, StatTile, shortDate } from "./kit";

const TONE = { present: "text-[#39FF14]", late: "text-amber-300", excused: "text-[#00E5FF]", absent: "text-red-300", injured: "text-orange-300" };

export function Attendance({ rows, names }) {
  const list = Array.isArray(rows) ? rows : [];
  if (!list.length) return <Empty title="No attendance logged" text="Attendance you take here or in the GAMEDAY app shows here." />;
  const byPlayer = {};
  list.forEach((r) => {
    const p = (byPlayer[r.player_id] ??= { present: 0, late: 0, excused: 0, absent: 0, injured: 0, total: 0 });
    const s = String(r.status ?? "").toLowerCase();
    if (s in p) p[s] += 1;
    p.total += 1;
  });
  const sessions = new Set(list.map((r) => r.date)).size;
  const rate = (p) => (p.total - p.injured > 0 ? Math.round((100 * (p.present + p.late)) / (p.total - p.injured)) : 0);
  const recent = [...list].sort((a, b) => String(b.date).localeCompare(String(a.date))).slice(0, 12);
  return (
    <div className="space-y-6" data-testid="attendance-view">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
        <StatTile label="Sessions" value={sessions} accent />
        <StatTile label="Players tracked" value={Object.keys(byPlayer).length} />
        <StatTile label="Check-ins" value={list.length} />
      </div>
      <div className="overflow-x-auto rounded-xl border border-[#1E293B]">
        <table className="w-full min-w-[560px] text-left text-sm" data-testid="attendance-table">
          <thead className="bg-[#162032] font-mono-gd text-[11px] uppercase tracking-wider text-slate-400">
            <tr>{["Player", "Present", "Late", "Excused", "Absent", "Injured", "Rate"].map((h) => <th key={h} className="px-3 py-2">{h}</th>)}</tr>
          </thead>
          <tbody>
            {Object.entries(byPlayer).map(([pid, p]) => (
              <tr key={pid} className="border-t border-[#1E293B] font-mono-gd text-slate-200">
                <td className="px-3 py-2 font-sans text-white">{names[pid] ?? "Player"}</td>
                <td className="px-3 py-2">{p.present}</td><td className="px-3 py-2">{p.late}</td>
                <td className="px-3 py-2">{p.excused}</td><td className="px-3 py-2">{p.absent}</td><td className="px-3 py-2">{p.injured}</td>
                <td className="px-3 py-2">
                  <div className="flex items-center gap-2">
                    <div className="h-1.5 w-16 overflow-hidden rounded-full bg-[#0A0E1A]"><div className="h-full bg-[#39FF14]" style={{ width: `${rate(p)}%` }} /></div>{rate(p)}%
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div>
        <p className="mb-2 font-mono-gd text-[11px] uppercase tracking-[0.2em] text-slate-400">Recent check-ins</p>
        <ul className="grid gap-2 sm:grid-cols-2">
          {recent.map((r) => (
            <li key={r.id} className="flex justify-between rounded-xl bg-[#162032] px-4 py-2 text-sm">
              <span className="text-white">{names[r.player_id] ?? "Player"}</span>
              <span className="font-mono-gd text-xs uppercase"><span className={TONE[String(r.status).toLowerCase()] ?? "text-slate-300"}>{r.status}</span> · <span className="text-slate-400">{shortDate(r.date)}</span></span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
